$(function () {
	'use strict'

	$('[data-toggle="offcanvas"]').on('click', function () {
		let offcanvas = $('.offcanvas-collapse');
		if (offcanvas.hasClass('open')) {
			offcanvas.toggleClass('open');
			window.setTimeout(function() {
				offcanvas.removeClass('offcanvas-open');
			}, 300);
		} else {
			offcanvas.addClass('offcanvas-open');
			window.setTimeout(function() {
				offcanvas.toggleClass('open');
			}, 20);
		}
		$('html').toggleClass('no-scroll');
	})
})

$(function () {
	'use strict'

	$('[data-toggle="modal"]').on('click', function () {
		$('html').addClass('no-scroll');
	})
	$('[data-dismiss="modal"]').on('click', function () {
		$('html').removeClass('no-scroll');
		$('.offcanvas-collapse').removeClass('open');
		// $('html').toggleClass('no-scroll');
	})
})